import React from 'react'

const ListOfCommands = () => {
    return (
        <div>
            home &nbsp; [home page]<br />
            about &nbsp; [about page]<br />
            contact &nbsp; [contact page]<br />
            cls  &nbsp; [clear console]<br />
            help  &nbsp; [list commands]<br />
        </div>
    )
}

export default ListOfCommands